import { firebaseConfig } from "./firebase";
import { releaseDetail } from "./release_details";

export const environment = {
    production: true,
    envName: 'staging',
    baseUrl: 'https://staging.my-masjid.com/api/',
    url: 'https://staging.my-masjid.com',
    refreshtimeout: '300000',
    stripeCard: 'a5d02348-d8c2-4fc4-a0c8-6977ff7c9018',
    version: releaseDetail.version,
    releaseDate: releaseDetail.date,
    firebase: firebaseConfig
};